<template>
<div>
    <v-row class="pa-3" style="cursor: pointer" @click="isReply = !isReply">
        <v-col cols="2">{{ reply.writer }}</v-col>
        <v-col>{{ reply.content }}</v-col>
        <v-col cols="2" class="text-right">
            <span>{{ formatDate(reply.createdAt) }}</span>
            <v-icon @click.stop="deleteReply" v-if="reply.writerId == user.id">delete</v-icon>
        </v-col>
    </v-row>
    <v-form ref="form" v-if="isReply">
        <div class="ma-2 ml-10 pa-4" style="border-radius: 10px; border: 1px solid grey">
            <v-row class="px-4">
                <span>{{ user.name }}</span>
                <v-spacer />
                <span>{{ contentCounter }}</span>
            </v-row>
            <v-textarea ref="content" dense v-model="content" rows="1" outlined auto-grow :rules="contentRule"></v-textarea>
            <div class="text-right">
                <v-btn class="pa-0 ma-0" tile color="primary" @click="writeSubReply">등 록</v-btn>
            </div>
        </div>
    </v-form>
    <div v-for="(item, i) in replies" :key="item.id">
        <v-row class="ma-2 ml-10" style="cursor: pointer; background: #f5f5f5; border-radius: 10px; border: 1px solid grey" @click="isReply = !isReply">
            <v-col cols="2">{{ item.writer }}</v-col>
            <v-col>{{ item.content }}</v-col>
            <v-col cols="2" class="text-right">
                <span>{{ formatDate(reply.createdAt) }}</span>
                <v-icon @click.stop="deleteSubReply(item.id, i)" v-if="reply.writerId == user.id">delete</v-icon>
            </v-col>
        </v-row>
    </div>
    <v-divider />
</div>
</template>

<script>
import {
    db,
    auth,
    functions
} from '@/firebase'
import {
    DateFormat
} from '@/mixins/date.js'

export default {
    name: 'reply',
    mixins: [
        DateFormat
    ],
    props: [
        'reply'
    ],
    data() {
        return {
            route: '',
            parentRef: '',
            isReply: false,
            content: '',
            contentRule: [
                v => {
                    if (!v) return '내용을 입력해주세요'
                    if (v.length > 300) return '300자를 넘을 수 없습니다'
                    return true
                }
            ],
            replies: []
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
        contentCounter() {
            return `${this.content.length} / 300`
        }
    },
    created() {
        const splits = this.$route.path.split("/")
        this.route = splits[1]
    },
    async mounted() {
        this.parentRef = db.collection(this.route).doc(this.$route.params.id).collection("replies").doc(this.reply.id)
        this.replies = await this.parentRef.collection("replies").orderBy('createdAt', 'desc').limit(5).parseCollection()
    },
    methods: {
        goToBoard() {
            this.$router.push(`/${this.route}`)
        },
        goTo(id) {
            this.$router.push(`/${this.route}/view/${id}`)
        },
        deleteReply() {
            if (!confirm('삭제하시겠습니까?')) return

            const deleteFn = functions.httpsCallable('recursiveDelete')
            
            deleteFn({
                path: this.parentRef.path,
                userId: this.user.id
            })

            this.$emit('delete', this.reply.id)
        },
        async writeSubReply() {
            if (!this.$store.getters.isLoggedIn) return this.showLoginToast()

            if (!this.$store.state.emailVerified) return this.showVerifyToast()

            if (!this.$refs.form.validate()) return

            const reply = {
                content: this.content,
                createdAt: Date.now(),
                writerId: this.user.id,
                writer: this.user.name,
            }

            const res = await this.parentRef.collection("replies").add(reply)

            reply.id = res.id
            this.replies.unshift(reply)
            this.isReply = false
            this.content = ""
            this.$refs.content.resetValidation()
        },
        async deleteSubReply(id, index) {
            if (!confirm("삭제하시겠습니까?")) return

            await this.parentRef.collection("replies").doc(id).delete()

            this.replies.splice(index, 1)
        }
    }
}
</script>
